import { render, staticRenderFns } from "./AdditionalServices.vue?vue&type=template&id=80231c22&"
import script from "./AdditionalServices.vue?vue&type=script&lang=js&"
export * from "./AdditionalServices.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalServices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports